<template>
  <SettingsBox
    title="Filtry"
    description="Zawężają listę produktów i potraw dostępnych podczas układania tego jadłospisu."
  >
    <Flex direction="column" :gap="4">
      <Text size="text-sm" color="color-text-text-secondary-700">Rodzaj diety</Text>
      <Flex direction="row" :gap="8">
        <template v-for="filter in filters" :key="filter.key">
          <div class="filter-item">
            <Checkbox
              v-if="enabled"
              class="filter"
              :label="filter.label"
              :model-value="filter.value"
              size="sm"
              @update:model-value="emit('update', filter.key, $event)"
            />
            <div v-else class="filter" @click="emit('upgrade')">
              <Checkbox disabled :label="filter.label" :model-value="false" size="sm" />
            </div>
          </div>
        </template>
      </Flex>
    </Flex>
  </SettingsBox>
</template>
<script lang="ts" setup>
  import { Checkbox, Flex } from '@/components/ui'
  import Text from '@/components/ui/Text/Text.vue'

  import { SettingsBox } from '../SettingsBox'

  defineProps<{
    enabled: boolean
    filters: { key: string; label: string; value: boolean }[]
  }>()
  const emit = defineEmits<{
    update: [key: string, value: boolean]
    upgrade: []
  }>()
</script>

<style lang="scss" scoped>

.filter-item {
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid var(--color-border-border-primary);
}
</style>
